import { useState } from 'react';
import { Phone, Menu, X, Zap } from 'lucide-react';
import { Button } from './ui/button';

export const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { href: '#services', label: 'Services' },
    { href: '#about', label: 'About' },
    { href: '#why-us', label: 'Why Choose Us' },
    { href: '#contact', label: 'Contact' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <a 
            href="#" 
            className="flex items-center gap-2 group"
            data-testid="nav-logo"
          >
            <div className="w-10 h-10 bg-yellow-400 flex items-center justify-center">
              <Zap className="w-6 h-6 text-black" aria-hidden="true" />
            </div>
            <div className="hidden sm:block">
              <span className="text-lg font-bold text-white tracking-tight">Fred Joules</span>
              <span className="block text-xs text-zinc-400 tracking-wider uppercase">Electricians</span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm text-zinc-300 hover:text-white transition-colors duration-200"
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-4">
            <span className="text-xs text-zinc-500 uppercase tracking-wider">Open 7 Days</span>
            <a
              href="tel:+19712652635"
              className="btn-primary flex items-center gap-2 px-5 py-2.5 font-semibold"
              data-testid="nav-call-button"
            >
              <Phone className="w-4 h-4" aria-hidden="true" />
              (971) 265-2635
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-white/10">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-zinc-300 hover:text-white py-2 transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                  data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {link.label}
                </a>
              ))}
              <a
                href="tel:+19712652635"
                className="btn-primary flex items-center justify-center gap-2 px-5 py-3 mt-2 font-semibold"
                data-testid="mobile-call-button"
              >
                <Phone className="w-4 h-4" aria-hidden="true" />
                Call (971) 265-2635
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
